import React from 'react'
import { Icon } from '@awell-health/design-system'
import {
  ActivityObjectType,
  ActivityAction,
  SubActivity,
  ActivitySubjectType
} from '../../../generated/types-orchestration'
import { SmallShellyAvatar } from '../../ShellyAvatar'

const getInitials = (name: string) => {
  const initialsArray = name.match(/\b(\w)/g)
  if (initialsArray) {
    return initialsArray.join('').slice(0, 2)
  }
  return ''
}

const createSubActivityIcon = (type: ActivityObjectType, subActivity: SubActivity, icon_url?: string): JSX.Element => {
  const { subject, action } = subActivity

  if (type === ActivityObjectType.EmrReport) {
    return (
      <Icon
        icon="RiUploadCloudFill"
        size={20}
        className={action === 'FAILED_TO_SEND' ? 'fill-red-500' : 'fill-green-500'}
      />
    )
  }

  if (type === ActivityObjectType.Agent) {
    return <Icon icon="RiSparklingFill" size={20} className="fill-yellow-400" />
  }

  if (type === ActivityObjectType.PluginAction) {
    return action === ActivityAction.Delegated ? (
      <SmallShellyAvatar />
    ) : (
      <img
        className="w-[20px] h-[20px] min-w-[20px] min-h-[20px] rounded-full border border-slate-200"
        src={icon_url}
        alt="Activity ExtensionIcon"
      />
    )
  }

  if (subject.type === ActivitySubjectType.Stakeholder || subject.type === ActivitySubjectType.User) {
    return (
      <div className="w-[20px] h-[20px] min-w-[20px] min-h-[20px] rounded-full bg-white flex items-center justify-center text-xs font-medium text-gray-700">
        {getInitials(subActivity.subject.name)}
      </div>
    )
  }

  return <SmallShellyAvatar />
}

export { createSubActivityIcon }
